import { $get } from '../axios';

// 账号设置-修改手机
export const changePhone = params => {
  return $get('/creator/', { act: 'change_phone', ...params });
};
// 账号权益
export const getAccEquity = params => {
  return $get('/creator/', { act: 'get_score_info', ...params });
};
//获取后台配置账号权益
// export const fetchRights = params => {
//   return $get('/creator/', { act: 'get_created_info', ...params });
// };
//获取创想值与等级配置
export const getAccountEquity = params => {
  return $get('/creator/', { act: 'get_created_info', ...params });
};

// 获取开发者基础信息
export const getAccount = params => {
  return $get('/creator/', { act: 'get_kfz_info', ...params });
};

export const bindUin = params => {
  return $get('/creator/', { act: 'change_bind_uin', ...params });
};

export const getCode = params => {
  return $get('/creator/', { act: 'comm_send_sms', ...params });
};

export const bindNewEmail = params => {
  return $get('/creator/', { act: 'change_email', ...params });
};

export const checkCode = params => {
  return $get('/creator/', { act: 'auth_comm_sms_code', ...params });
};

export const getLevel = params => {
  return $get('/creator/', { act: 'get_score_info', ...params });
};

export const getIframeUrl = params => {
  return $get('/creator/', { act: 'get_tipalti_frame', ...params });
};

export const getdrawOutList = params => {
  return $get('/creator/', { act: 'get_wallet_detail', ...params });
};

//获取国家语言码
export const getCountry = params => {
  return $get('/gate/', { act: 'get_country', ...params });
};
// 注册
export const registration = params => {
  return $get('/creator/', { act: 'auth_develop_info', ...params });
};
export const developJudgment = params => {
  return $get('/creator/', { act: 'get_kfz_info', ...params });
};
